export enum Situacoes {
    'Inativo' = 1,
    'Ativo' = 2,
    'Aguardando entrega de Documentação Física' = 3,
    'Aguardando análise no CRC - Gestor' = 4,
    'Em análise no CRC - Gestor' = 5,
    'Aguardando análise no CRC - Comissão' = 6,
    'Em análise no CRC - Comissão' = 7,
    'Aguardando análise no CFC - Gestor' = 8,
    'Em análise no CFC - Gestor' = 9,
    'Aguardando análise no CFC - Comissão' = 10,
    'Em análise no CFC - Comissão' = 11,
    'Deferido' = 12,
    'Devolvido para Adequação' = 13,
    'Aberto para Recurso' = 14,
    'Processo Finalizado' = 15,
    'Iniciado' = 16,
    'Em Análise' = 17,
    'Autorizado' = 18,
    'Cancelado' = 19,
    'Agendada' = 20,
    'Em Execução' = 21,
    'Aguardando' = 22,
    'Concluído' = 23,
    'Indeferido' = 24,
    'Rejeitado por Improcedência' = 25,
    'Excluído pelo Usuário' = 26,
    'Aguardando Câmara/Plenária - CRC - Deferido' = 27,
    'Aguardando Câmara/Plenária - CFC - Deferido' = 28,
    'Baixada por Decurso de Prazo' = 29,
    'Aguardando Câmara/Plenária - CRC - Indeferido' = 30,
    'Aguardando Câmara/Plenária - CFC - Indeferido' = 31,
}

export enum MotivoJustificativa {
    'Atestado Médico' = 1,
    'Licença Maternidade' = 2,
    'Licença Paternidade' = 3,
    'Enfermidades' = 4,
    'Acidente de Trabalho' = 5,
    'Outras Situações' = 6
}

export enum Ano {
    'Ano de 2020' = 1,
    'Ano de 2019' = 2,
}

export enum FuncaoExercida {
    'Auditor Independente' = 1,
    'Profissionais de Grandes Empresas' = 2,
    'Perito' = 3,
    'Facultativo' = 4,
    'Profissional Previc' = 5,
    'ProRT' = 6,
}

export enum HipoteseAuditorIndependente {
    'Sócio' = 1,
    'Responsável Técnico' = 2,
    'Direção ou Gerencia Técnica' = 3,
    'Auditor Previc' = 4,
    'Auditor CNAI' = 5
}

export enum HipoteseProfissionaisDeGrandesEmpresas {
    'Responsável Técnico Previc' = 1,
    'Responsável Técnico' = 2,
    'Gerente/Chefia na Área Contábil' = 3
}

export enum HipotesePerito {
    'Perito Contábil' = 1
}

export enum HipoteseFacultativo {
    'Facultativo' = 1
}

export enum HipoteseProfissionalPrevic {
    'Previc' = 1
}

export enum HipoteseProRt {
    'ProRT' = 1
}

export enum EnderecoTipo {
    Comercial = 1,
    Residencial = 2
}

export enum TelefoneTipo {
    Residencial = 1,
    Comercial = 2,
    Celular = 3,
    Fax = 4
}

export enum TipoPrestacaoConta {
    conhecimento = 1,
    docencia = 2,
    comissao_banca = 3,
    producao_intelectual = 4
}

export enum Hipoteses {
    'Hipóteses*' = 0,
    'Hipóteses das alíneas (a), (b), (c), (d) e (e) do Item 4 da NBC PG 12 (R2)*' = 1,
    'Hipóteses das alíneas (f) do Item 4 da NBC PG 12 (R2)*' = 2,
    'Hipóteses das alíneas (g) do Item 4 da NBC PG 12 (R2)*' = 3,
    'Realizei atividades de EPC mesmo não estando incuído em nenhuma das situações previstas no item 4 da NBC PG 12 (R2)*' = 4,
}
export enum GrupoAtividade {
    Aquisição_de_conhecimento = 1,
    Docencia = 2,
    Atuação_como_participante = 3,
    Producao_Intelectual = 4
}

export enum TipoPosGraduacao {
    Especialização = 1,
    MBA = 2,
    Mestrado = 3,
    Doutorado = 4,
    Graduação = 5
}

export enum TipoMensagem {
    'success' = 1,
    'info' = 2,
    'warn' = 3,
    'error' = 4
}

export enum CabecalhoMensagens {
    'Mensagem de Confirmação' = 1,
    'Mensagem de Sucesso' = 2,
    'Mensagem de Aviso' = 3,
    'Mensagem de Erro' = 4,
    'Mensagem Informativa' = 5
}

export enum Atividades {
    Capacitadora = 0,
    Docencia = 2,
    CursosNoExterior = 3,
    ProducaoIntelectual = 5,
    Comissao = 6,
    Curso = 8,
    Evento = 9,
    PosGraduacao = 10,
    OrientacaoEBanca = 11
}

export enum Porte {
    'Pequeno Porte' = 1,
    'Médio Porte' = 2,
    'Grande Porte' = 3,
    'Porte' = 4
}

export enum TipoDecisao {
    Deferir = 1,
    Indeferir = 2,
}

export enum Lotacoes {
    CFC = 'CFC',
    CRC_AC = 'AC',
    CRC_AL = 'AL',
    CRC_AM = 'AM',
    CRC_AP = 'AP',
    CRC_BA = 'BA',
    CRC_CE = 'CE',
    CRC_DF = 'DF',
    CRC_ES = 'ES',
    CRC_GO = 'GO',
    CRC_MA = 'MA',
    CRC_MG = 'MG',
    CRC_MS = 'MS',
    CRC_MT = 'MT',
    CRC_PA = 'PA',
    CRC_PB = 'PB',
    CRC_PE = 'PE',
    CRC_PI = 'PI',
    CRC_PR = 'PR',
    CRC_RJ = 'RJ',
    CRC_RN = 'RN',
    CRC_RO = 'RO',
    CRC_RR = 'RR',
    CRC_RS = 'RS',
    CRC_SC = 'SC',
    CRC_SE = 'SE',
    CRC_SP = 'SP',
    CRC_TO = 'TO',
}

export enum LotacoesAtividades {
    CFC = 'CFC',
    CRC_AC = 'CRC-AC',
    CRC_AL = 'CRC-AL',
    CRC_AM = 'CRC-AM',
    CRC_AP = 'CRC-AP',
    CRC_BA = 'CRC-BA',
    CRC_CE = 'CRC-CE',
    CRC_DF = 'CRC-DF',
    CRC_ES = 'CRC-ES',
    CRC_GO = 'CRC-GO',
    CRC_MA = 'CRC-MA',
    CRC_MG = 'CRC-MG',
    CRC_MS = 'CRC-MS',
    CRC_MT = 'CRC-MT',
    CRC_PA = 'CRC-PA',
    CRC_PB = 'CRC-PB',
    CRC_PE = 'CRC-PE',
    CRC_PI = 'CRC-PI',
    CRC_PR = 'CRC-PR',
    CRC_RJ = 'CRC-RJ',
    CRC_RN = 'CRC-RN',
    CRC_RO = 'CRC-RO',
    CRC_RR = 'CRC-RR',
    CRC_RS = 'CRC-RS',
    CRC_SC = 'CRC-SC',
    CRC_SE = 'CRC-SE',
    CRC_SP = 'CRC-SP',
    CRC_TO = 'CRC-TO',
}

export enum LotacoesId {
    CFC = 1,
    CRC_AC = 2,
    CRC_AL = 3,
    CRC_AM = 4,
    CRC_AP = 5,
    CRC_BA = 6,
    CRC_CE = 7,
    CRC_DF = 8,
    CRC_ES = 9,
    CRC_GO = 10,
    CRC_MA = 11,
    CRC_MG = 12,
    CRC_MS = 13,
    CRC_MT = 14,
    CRC_PA = 15,
    CRC_PB = 16,
    CRC_PE = 17,
    CRC_PI = 18,
    CRC_PR = 19,
    CRC_RJ = 20,
    CRC_RN = 21,
    CRC_RO = 22,
    CRC_RR = 23,
    CRC_RS = 24,
    CRC_SC = 25,
    CRC_SE = 26,
    CRC_SP = 27,
    CRC_TO = 28
}

export enum FiltroDeResultados {
    'Todos' = 1,
    'Apenas com Rascunho' = 2,
    'Apenas Sem Rascunho' = 3
}



// WEBPACK FOOTER //
// ./src/app/entity/enumeraveis.ts